export class AccountRecoveryUser {
  constructor(private userId: number, private token: string, private password?: string, private verifypassword?: string) {
  }
}
